import React from 'react';
import { Text, StyleSheet, Image, View, Link } from '@react-pdf/renderer';
import BrumBreathes from '../../../../assets/images/bcc/brum-breathes.png';
import LogoSmall from '../../../../assets/images/bcc/logo-small.png';

type Props = {
  events: { dateLocation: string; name: string; link: string }[];
};

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    color: '#4E73C3',
  },
  paragraph: {
    marginBottom: 0,
    fontSize: 11,
    color: '#000',
    lineHeight: 1.5,
    letterSpacing: -0.32,
  },
});

const ThirdPage = ({ events }: Props) => {
  return (
    <View>
      <Text style={{ ...styles.title, marginBottom: 16 }}>
        How can we all help improve air quality for our children?
      </Text>
      <View
        style={{
          width: '100%',
          maxWidth: 499,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: 16,
        }}
      >
        <Text
          style={{
            width: 128,
            textAlign: 'right',
            flexShrink: 0,
            marginRight: 16,
            fontSize: 11,
            fontFamily: 'Helvetica-Bold',
          }}
        >
          Raise Awareness
        </Text>
        <Text style={{ ...styles.paragraph, width: '100%', maxWidth: 371 }}>
          Talk to your children about the importance of air quality and know
          your local pollution levels by checking your school’s air quality
          monitor.
        </Text>
      </View>
      <View
        style={{
          width: '100%',
          maxWidth: 499,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: 16,
        }}
      >
        <Text
          style={{
            width: 128,
            textAlign: 'right',
            flexShrink: 0,
            marginRight: 16,
            fontSize: 11,
            fontFamily: 'Helvetica-Bold',
          }}
        >
          Advocate for Change
        </Text>
        <Text style={{ ...styles.paragraph, width: '100%', maxWidth: 371 }}>
          Support local initiatives that aim to reduce pollution, like ‘School
          Streets’, Modeshift STARS, ‘Switch-Off School Streets’, ‘Walk to
          School Month’ and Clean Air Cops.
        </Text>
      </View>
      <View
        style={{
          width: '100%',
          maxWidth: 499,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: 32,
        }}
      >
        <Text
          style={{
            width: 128,
            textAlign: 'right',
            flexShrink: 0,
            marginRight: 16,
            fontSize: 11,
            fontFamily: 'Helvetica-Bold',
          }}
        >
          Stay Informed
        </Text>
        <Text style={{ ...styles.paragraph, width: '100%', maxWidth: 371 }}>
          Keep an eye on the local air quality through the MyAir web app so that
          you can track daily air pollution levels.
        </Text>
      </View>
      <Text style={{ ...styles.title, marginBottom: 16 }}>
        Upcoming Air Quality Events in your Area
      </Text>
      <View
        style={{
          maxWidth: 499,
          maxHeight: 388,
          height: '100%',
          borderTop: '1px solid #CBD5E0',
        }}
      >
        {events.map((event, id) => {
          const cleanLink = event.link ? event.link.trim() : '';
          return (
            <View
              key={id}
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 8,
                backgroundColor: id % 2 === 0 ? '#FFF' : '#F7FAFC',
              }}
            >
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{ ...styles.paragraph, fontFamily: 'Helvetica-Bold' }}
                >
                  {event.name}
                </Text>
                <Text style={{ fontSize: 11, color: '#1A202C' }}>
                  {event.dateLocation}
                </Text>
              </View>
              {cleanLink ? (
                <Link
                  src={cleanLink}
                  style={{ fontSize: 10, color: '#4A5568' }}
                >
                  {cleanLink}
                </Link>
              ) : null}
            </View>
          );
        })}
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: 52,
          alignItems: 'center',
        }}
      >
        <Image style={{ width: 156, height: 52 }} src={BrumBreathes} />
        <Link
          style={{ fontSize: 10, fontWeight: 300, color: '#4A5568' }}
          src="https://www.brumbreathes.co.uk/info/25/welcome-2/55/education-1/2"
        >
          https://www.brumbreathes.co.uk/info/25/welcome-2/55/education-1/2
        </Link>
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: 52,
          alignItems: 'center',
        }}
      >
        <Image style={{ width: 156, height: 52 }} src={LogoSmall} />
        <View style={{ display: 'flex', flexDirection: 'column' }}>
          <Link
            style={{
              fontSize: 10,
              fontWeight: 300,
              color: '#4A5568',
              height: 20,
            }}
            src="https://www.birmingham.gov.uk/info/50347/neighbourhoods_and_schools"
          >
            https://www.birmingham.gov.uk/info/50347/neighbourhoods_and_schools
          </Link>
          <Link
            style={{
              fontSize: 10,
              fontWeight: 300,
              color: '#4A5568',
              height: 20,
            }}
            src="http://www.birmingham.gov.uk/modeshiftstars"
          >
            http://www.birmingham.gov.uk/modeshiftstars
          </Link>
        </View>
      </View>
    </View>
  );
};

export default ThirdPage;
